import { useState } from 'react';
import api from 'service/api';
import { useAuth } from 'hook/auth';

export const useUserScales = () => {
  const { requestIntercept } = useAuth();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const getUserScales = async (user_id) => {
    if (!user_id) return;
    setLoading(true);
    try {
      const response = await requestIntercept(
        api.get,
        `/v2/admin/users/${user_id}/scales`
      );
      if (response?.status === 200) {
        setData(response.data?.data || []);
      }
    } catch {
      setData([]);
    } finally {
      setLoading(false);
      setLoaded(true);
    }
  };

  return { data, loading, loaded, getUserScales };
};
